"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizeOverrides = void 0;
exports.sizeOverrides = [
    {
        props: { size: 'XS' },
        style: {
            borderRadius: '1.25rem',
            padding: '0.375rem 1rem',
            minHeight: '2rem',
        },
    },
    {
        props: { size: 'S' },
        style: {
            borderRadius: '1.625rem',
            padding: '1rem 1.5rem',
            minHeight: '3.25rem',
        },
    },
    {
        props: { size: 'M' },
        style: {
            borderRadius: '1.625rem',
            padding: '1rem 1.5rem',
            minHeight: '3.25rem',
        },
    },
    {
        props: { size: 'L' },
        style: {
            borderRadius: '2rem',
            padding: '1.375rem 1.75rem',
            minHeight: '4rem',
        },
    },
    {
        props: { size: 'XS', variant: 'tertiaryDefault' || 'tertiaryHC' },
        style: {
            borderRadius: '1.25rem',
            padding: '0.375rem 0.5rem',
            minHeight: '2rem',
        },
    },
    {
        props: { size: 'S', variant: 'tertiaryDefault' || 'tertiaryHC' },
        style: {
            borderRadius: '1.625rem',
            padding: '0.625rem 0.5rem',
            minHeight: '3.25rem',
        },
    },
    {
        props: { size: 'M', variant: 'tertiaryDefault' || 'tertiaryHC' },
        style: {
            borderRadius: '1.625rem',
            padding: '1rem 0.5rem',
            minHeight: '3.25rem',
        },
    },
    {
        props: { size: 'L', variant: 'tertiaryDefault' || 'tertiaryHC' },
        style: {
            borderRadius: '2rem',
            padding: '1.125rem 0.5rem',
            minHeight: '4rem',
        },
    },
];
